module.exports = __webpack_public_path__ + "static/meta-image.d6a68c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meta-image.png
// module id = 1095
// module chunks = 35783957827783